export default "__VITE_ASSET__5134eade__"